import styled, { css } from 'styled-components';
export const StyledFlex = styled.div `
  display: flex;

  ${({ $borderTop }) => {
    if ($borderTop)
        return css `
        border-top: ${$borderTop};
      `;
    return css ``;
}};

  ${({ $borderBottom }) => {
    if ($borderBottom)
        return css `
        border-bottom: ${$borderBottom};
      `;
    return css ``;
}};

  ${({ $gap }) => {
    if ($gap)
        return css `
        gap: ${$gap};
      `;
    return css ``;
}};

  ${({ $margin }) => {
    if ($margin)
        return css `
        margin: ${$margin};
      `;
    return css ``;
}};
  ${({ $padding }) => {
    if ($padding)
        return css `
        padding: ${$padding};
      `;
    return css ``;
}};
  ${({ $flexDirection }) => {
    if ($flexDirection)
        return css `
        flex-direction: ${$flexDirection};
      `;
    return css ``;
}};
  ${({ $alignContent }) => {
    if ($alignContent)
        return css `
        align-content: ${$alignContent};
      `;
    return css ``;
}};
  ${({ $alignSelf }) => {
    if ($alignSelf)
        return css `
        align-self: ${$alignSelf};
      `;
    return css ``;
}};
  ${({ $alignItems }) => {
    if ($alignItems)
        return css `
        align-items: ${$alignItems};
      `;
    return css ``;
}};
  ${({ $justifyContent }) => {
    if ($justifyContent)
        return css `
        justify-content: ${$justifyContent};
      `;
    return css ``;
}};
  ${({ $justifySelf }) => {
    if ($justifySelf)
        return css `
        justify-self: ${$justifySelf};
      `;
    return css ``;
}};
  ${({ $justifyItems }) => {
    if ($justifyItems)
        return css `
        justify-items: ${$justifyItems};
      `;
    return css ``;
}};
  ${({ $width }) => {
    if ($width)
        return css `
        width: ${$width};
      `;
    return css ``;
}};
  ${({ $minWidth }) => {
    if ($minWidth)
        return css `
        min-width: ${$minWidth};
      `;
    return css ``;
}};
  ${({ $maxWidth }) => {
    if ($maxWidth)
        return css `
        max-width: ${$maxWidth};
      `;
    return css ``;
}};
  ${({ $height }) => {
    if ($height)
        return css `
        height: ${$height};
      `;
    return css ``;
}};
  ${({ $minHeight }) => {
    if ($minHeight)
        return css `
        min-height: ${$minHeight};
      `;
    return css ``;
}};
  ${({ $maxHeight }) => {
    if ($maxHeight)
        return css `
        max-height: ${$maxHeight};
      `;
    return css ``;
}};
  ${({ $flex }) => {
    if ($flex)
        return css `
        flex: ${$flex};
      `;
    return css ``;
}};
  ${({ $flexWrap }) => {
    if ($flexWrap)
        return css `
        flex-wrap: ${$flexWrap};
      `;
    return css ``;
}};
  ${({ $flexBasis }) => {
    if ($flexBasis)
        return css `
        flex-basis: ${$flexBasis};
      `;
    return css ``;
}};
  ${({ $flexShrink }) => {
    if ($flexShrink)
        return css `
        flex-shrink: ${$flexShrink};
      `;
    return css ``;
}};
  ${({ $flexGrow }) => {
    if ($flexGrow)
        return css `
        flex-grow: ${$flexGrow};
      `;
    return css ``;
}};

  ${({ $order }) => {
    if ($order)
        return css `
        order: ${$order};
      `;
    return css ``;
}};

  ${({ $childMarginRight }) => {
    if ($childMarginRight)
        return css `
        > * {
          margin-right: ${$childMarginRight};
          &:last-child {
            margin-right: 0;
          }
        }
      `;
    return css ``;
}};

  ${({ $childMarginLeft }) => {
    if ($childMarginLeft)
        return css `
        > * {
          margin-left: ${$childMarginLeft};
          &:last-child {
            margin-left: 0;
          }
        }
      `;
    return css ``;
}};

  ${({ $childMarginTop }) => {
    if ($childMarginTop)
        return css `
        > * {
          margin-top: ${$childMarginTop};
          &:last-child {
            margin-top: 0;
          }
        }
      `;
    return css ``;
}};
  ${({ $childMarginBottom }) => {
    if ($childMarginBottom)
        return css `
        > * {
          margin-bottom: ${$childMarginBottom};
          &:last-child {
            margin-bottom: 0;
          }
        }
      `;
    return css ``;
}}; ;
`;
//# sourceMappingURL=Flex.styled.js.map